import { Shift4ErrorType } from './payment.model';

export function isValidationShift4Error(error: Shift4ErrorType): error is Shift4ErrorType {
  return error.type === 'validation_error';
}
